import { useCallback } from "react";
import { TextField } from "./Parts/index";
import { Button } from "@/components/Buttons";
import { ErrorMessage } from "@/components/Form/Parts/index";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CouponCodeForm(_ref) {
  var enable = _ref.enable,
      register = _ref.register,
      apply = _ref.apply,
      error = _ref.error;
  var handleClick = useCallback(function () {
    if (typeof apply === "function") {
      apply();
    }
  }, [apply]);
  if (!enable) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.couponCode,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.explanation,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u30AF\u30FC\u30DD\u30F3\u30B3\u30FC\u30C9\u3092\u304A\u6301\u3061\u306E\u65B9\u306F\u5165\u529B\u5F8C\u3001\u9069\u7528\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u8907\u6570\u306E\u5272\u5F15\u304C\u9069\u7528\u3055\u308C\u308B\u5834\u5408\u3001\u6700\u3082\u5272\u5F15\u984D\u306E\u5927\u304D\u3044\u5272\u5F15\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002"]
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.formGroup,
      children: [/*#__PURE__*/_jsx(TextField, {
        ref: register,
        name: "couponCode",
        placeholder: "\u304A\u6301\u3061\u306E\u5834\u5408\u306F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
      }), /*#__PURE__*/_jsx(Button, {
        fillColor: true,
        small: true,
        inline: true,
        onClick: handleClick,
        children: "\u9069\u7528"
      })]
    })]
  });
}